import {
  FileSyncOutlined,
  IdcardOutlined,
  MailOutlined,
  SignatureOutlined,
  TeamOutlined,
  SettingOutlined,
  FileTextOutlined,
  LayoutOutlined,
  UserOutlined,
  HistoryOutlined,
  DashboardOutlined,
  UsergroupAddOutlined,
  ContactsOutlined,
  SafetyCertificateOutlined
} from '@ant-design/icons';

const icons = {
  FileSyncOutlined,
  IdcardOutlined,
  MailOutlined,
  SignatureOutlined,
  TeamOutlined,
  SettingOutlined,
  FileTextOutlined,
  LayoutOutlined,
  UserOutlined,
  HistoryOutlined,
  DashboardOutlined,
  UsergroupAddOutlined,
  ContactsOutlined,
  SafetyCertificateOutlined
};

const axiusUsersConfig = {
  id: 'group-users',
  title: 'Usuarios',
  type: 'group',
  children: [
    {
      id: 'axius-users-config',
      title: 'Usuarios',
      type: 'collapse',
      icon: icons.UserOutlined,
      children: [
        {
          id: 'users-roles-config',
          title: 'Todos los usuarios',
          type: 'item',
          url: '/axius/users',
          icon: icons.TeamOutlined,
          breadcrumbs: true,
          permissions: ['user.read-all']
        },
        {
          id: 'roles-permissions-config',
          title: 'Roles y Permisos',
          type: 'item',
          url: '/axius/roles-permissions',
          icon: icons.SafetyCertificateOutlined,
          breadcrumbs: true,
          permissions: ['role.read-all']
        }
      ]
    }
  ]
};
export default axiusUsersConfig;
